module.exports = __webpack_public_path__ + "logiciel_rip.png?dd0d095c960234c37a62d9fafe429c93";